import { Link } from "react-router-dom";
import { company, navigation } from "@/data/content";

export const Footer = () => (
  <footer className="border-t border-border bg-background pb-24 md:pb-0" data-testid="footer">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-5 py-14 sm:grid-cols-2 lg:grid-cols-4 lg:px-10 lg:py-16">
      <div>
        <p className="text-lg font-bold tracking-[0.18em] text-foreground">{company.name}</p>
        <p className="mt-3 max-w-xs text-sm leading-relaxed text-muted-foreground">
          Rekonstrukce bytů, rodinných domů, zateplení fasád a zednické práce
          v Plzni a okolí.
        </p>
      </div>
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-muted-foreground">
          Navigace
        </p>
        <ul className="mt-4 flex flex-col gap-2.5">
          {navigation.map((item) => (
            <li key={item.label}>
              <Link
                to={item.href}
                className="text-sm text-foreground/80 transition-colors hover:text-accent"
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-muted-foreground">
          Kontakt
        </p>
        <ul className="mt-4 flex flex-col gap-2.5 text-sm text-foreground/80">
          <li className="font-semibold text-foreground">{company.name} s.r.o.</li>
          <li>{company.owner} – jednatel</li>
          <li>
            <a href={company.phoneHref} data-testid="footer-phone" className="font-semibold text-foreground transition-colors hover:text-accent">
              {company.phone}
            </a>
          </li>
          <li>
            <a href={company.emailHref} data-testid="footer-email" className="transition-colors hover:text-accent">
              {company.email}
            </a>
          </li>
          <li>{company.city}</li>
          <li className="text-muted-foreground">IČO {company.ico}</li>
        </ul>
      </div>
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-muted-foreground">
          Informace
        </p>
        <ul className="mt-4 flex flex-col gap-2.5 text-sm">
          <li>
            <Link to="/ochrana-osobnich-udaju" className="text-foreground/80 transition-colors hover:text-accent">
              Ochrana osobních údajů
            </Link>
          </li>
          <li>
            <Link to="/cookies" className="text-foreground/80 transition-colors hover:text-accent">
              Cookies
            </Link>
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-border">
      <div className="mx-auto flex max-w-7xl flex-col gap-2 px-5 py-5 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between lg:px-10">
        <p>© {new Date().getFullYear()} {company.legalName} · Plzeň</p>
        <p className="font-serif-accent italic">{company.claim}</p>
      </div>
    </div>
  </footer>
);
